<template>
  <div id="app">
    <Login @closeLoginModal="closeLoginModal" @loginOKHandler="loginOKHandler" />
    <layout v-if="isLayout && isRouterAlive">
      <router-view />
    </layout>
    <div v-else-if="!isLayout && isRouterAlive">
      <router-view />
    </div>
  </div>
</template>

<script>
  import Login from './components/login';
  import { getCookie } from '@/utils/utils';
  import layout from '@/components/layout/index';
  export default {
    name: 'App',
    data() {
      return {
        isLayout: true,
        isRouterAlive: true
      }
    },
    provide() {
      return {
        reload: this.reload
      }
    },
    watch: {
      isRouterAlive(newVal, oldVal) {
        console.log(`newVal: ${newVal} - oldVal: ${oldVal}`);
      }
    },
    components: {
      layout,
      Login
    },
    watch: {
      '$route':'getPath'
    },
    async created() {
      // 解决vue页面跳转时总会显示首页
      if(this.$route.fullPath !== '/' || this.$route.fullPath !== '/index'){
        this.$router.replace(
          { path: this.$route.fullPath },
          onComplete => {},
          onAbort => {}
        )
      }
      
      this.getPath();
      if (!this.isLayout) {
        const uid = getCookie('uid');
        if (!uid && !this.$route.fullPath.includes('person')) return;
        await this.$store.dispatch('user/getInfo');
      }
      
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        });
      },
      getPath() {
       if (this.$route.name === 'videoRoomChild' || this.$route.name === 'proxyPage') {
         this.isLayout = false;
       }else {
         this.isLayout = true;
       }
      },
      closeLoginModal() {
        this.$store.dispatch('user/openLogin', false);
      },
      loginOKHandler() {
        this.$store.dispatch('user/openLogin', false)
        this.loginOk = true;
      },
    }
  }
</script>

<style>
  body {
    margin: 0; padding: 0;
  }
  #app {
    background-color: rgba(242,242,244,1);
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue